import { render, staticRenderFns } from "./SoftbooksSearchResultPage.vue?vue&type=template&id=aa9d70ba&"
import script from "./SoftbooksSearchResultPage.ts?vue&type=script&lang=ts&"
export * from "./SoftbooksSearchResultPage.ts?vue&type=script&lang=ts&"
import style0 from "./SoftbooksSearchResultPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SoftbooksSearchResultPage.vue"
export default component.exports